module.exports = __webpack_public_path__ + "img/icon_dashboard_blue.ce6d459e.svg";